module.exports = __webpack_public_path__ + "static/img/tencent.2ad277b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tencent.png
// module id = dhXq
// module chunks = 1